export const isBlockAnimation = (type?: string) => {
	if (!type) return false
	return [
		'increase',
		'decrease',
		'appearance',
		'sliding',
		'disclosure',
	].includes(type)
}
